import React from "react";
import Container from "@material-ui/core/Container";

import Header from "./components/Header";
import About from "./components/About";
import SuperStars from "./components/SuperStars";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Header />
      <Container>
        <About />
      </Container>
      <SuperStars />
      <Footer/>
    </>
  );
}

export default App;
